import { useDataCatalog } from "@/composable/data-catalog";
import { SpectrumType } from "@soft-db/data-formatter";
import { SoftSelect } from "@soft-db/ui";
import { useVModel } from "@vueuse/core";
import { defineComponent, PropType } from "vue";

export default defineComponent({
	name: "SpectrumSelection",

	props: {
		modelValue: String as PropType<SpectrumType | "">,
	},

	setup(props) {
		const { t } = useI18n();
		const vModel = useVModel(props, "modelValue");

		const { generateMenuEntries, Spectrum } = useDataCatalog();

		const spectrumTypes = generateMenuEntries(Spectrum);

		return () => (
			<SoftSelect
				v-model={vModel.value}
				label={t("dashboard.plugins.spectrum")}
				items={spectrumTypes}
				itemText="name"
				itemValue="value"
			/>
		);
	},
});
